// https://vuex.vuejs.org/en/actions.html
import orderService from '@/services/orderService'
import store from '@/store'
import objectHelper from '@/helpers/objectHelper'

export default {
  async RefreshOrders (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Loading Orders')
    var apiResult = await orderService.getOverview()
    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return apiResult
    }
    context.commit('refreshOrders', apiResult.value)
    // load the dependencies
    if (store.state.customers.data.length < 1) {
      await store.dispatch('RefreshCustomers')
    }
    if (store.state.products.list.length < 1) {
      await store.dispatch('RefreshProducts')
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async CreateOrder (context, order) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Creating Order')
    var apiResult = await orderService.create(order)

    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return false
    }

    context.commit('updateOrder', apiResult.value)
    context.dispatch('ResetBasket')

    store.dispatch('RemoveLoadingMessage', loadingId)
    return true
  },
  UpdateBasket (context, basket) {
    var newBasket = {
      customerId: basket.customerId,
      poNumber: basket.poNumber,
      internalRemarks: basket.internalRemarks,
      items: [],
    }
    basket.items.forEach(item => {
      var newItem = {
        productId: item.productId,
        variantId: item.variantId,
        quantity: item.quantity,
        extraProperties: item.extraProperties,
      }
      if (objectHelper.objectHasNonDefaultFields(newItem) === false) {
        return
      }
      newBasket.items.push(newItem)
    })
    context.commit('updateBasket', newBasket)
  },
  ResetBasket (context, basket) {
    context.commit('updateBasket', {
      customerId: '',
      poNumber: '',
      internalRemarks: '',
      items: [],
    })
  },
  async ResetOrders (context) {
    context.commit('refreshOrders', [])
  },
}
